import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row, Image } from "antd";
import { SpinCentro } from "../../../../components/spin/SpinCentro";
import ThumbnailFoto from "./ThumbnailFoto";
import travoltaImg from "../../../../assets/travolta.png";

export default function ListaFotos() {
  const { asistencia } = useSelector((state) => state.detalleReducer);
  const [fotosIds, setFotosIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (asistencia && asistencia.idFotos && asistencia.idFotos.length > 0) {
      const fotos = asistencia.idFotos.map((id, index) => ({
        id: id,
        nombre: `Foto ${index + 1}`,
        tipo: "foto",
      }));
      setFotosIds(fotos);
    } else {
      setFotosIds([]);
    }
    setLoading(false);
  }, [asistencia]);

  if (loading) {
    return <SpinCentro />;
  }

  if (fotosIds.length === 0) {
    return (
      <div className="fotos-empty-container">
        <img src={travoltaImg} alt="No hay fotos" className="fotos-empty-travolta" />
        <div className="fotos-empty-text">
          No hay fotos disponibles para este servicio
        </div>
      </div>
    );
  }

  return (
    <Image.PreviewGroup
      preview={{
        toolbarRender: (
          _,
          {
            transform: { scale },
            actions: { onZoomOut, onZoomIn, onReset },
          }
        ) => (
          <div className="preview-toolbar-container">
            <button onClick={onZoomOut} className="preview-toolbar-button">
              Zoom -
            </button>
            <button onClick={onZoomIn} className="preview-toolbar-button">
              Zoom +
            </button>
            <button onClick={onReset} className="preview-toolbar-button">
              Resetear
            </button>
          </div>
        ),
      }}
    >
      <Row gutter={[16, 16]} className="fotos-grid-container">
        {fotosIds.map((foto, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6}>
            <ThumbnailFoto foto={foto} />
          </Col>
        ))}
      </Row>
    </Image.PreviewGroup>
  );
}